"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var useTranslationNs_1 = require("../../hooks/useTranslationNs");
var classnames_1 = __importDefault(require("classnames"));
var FilterSummary = function (_a) {
    var children = _a.children, handleClick = _a.handleClick, label = _a.label, _b = _a.isDisabled, isDisabled = _b === void 0 ? false : _b;
    var getTranslation = useTranslationNs_1.useTranslationNs('common', 'FILTER');
    return (react_1.default.createElement("div", { onClick: handleClick, className: classnames_1.default('filter-summary', {
            'disabled-filter': isDisabled,
        }) },
        react_1.default.createElement("div", null,
            react_1.default.createElement("label", null, getTranslation(label)),
            react_1.default.createElement("div", { className: "selected-val" }, children)),
        react_1.default.createElement("i", { className: "cm-icon icon-dropdown-arrow" })));
};
exports.default = FilterSummary;
